// Session TTL in seconds (5 minutes)
export const SESSION_TTL_SECONDS = 5 * 60;
// Heartbeat interval in milliseconds (60 seconds)
export const HEARTBEAT_INTERVAL_MS = 60 * 1000;
//# sourceMappingURL=session.js.map